import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "src/@/components/ui/multi-select";
import useAuth from "src/hooks/useAuth";
import v2_actionListaTagsChats from "src/actions/v2/chats/v2_actionListaTagsChats";
import { AlertInfo } from "src/@/components/shared/AlertInfo";


const ChatAddTag = ({ block, changeBlock }) => {
  const { t } = useTranslation('automation');
  const { cliente } = useAuth();
  const [listaTags, setListaTags] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    // Atualiza o estado local quando o bloco muda
    if (block?.data?.chatTags) {
      setTags(block?.data?.chatTags);
    }
  }, [block]);

  async function buscarListaTags() {
    try {
      const querys = `?cliente_id=${cliente._id}`;
      const response = await v2_actionListaTagsChats(querys);
      setListaTags(response.data.data);
    } catch (error) {
      console.error("Erro ao buscar lista de tags:", error);
    }
  }

  useEffect(() => {
    buscarListaTags();
  }, [block]);

  const listFormat = listaTags.map((tag) => ({
    value: tag._id,
    label: tag.nome,
  }));

  return (
    <div className="w-full">


      <MultiSelect
        options={listFormat}
        onValueChange={(selectedValues) => {
          const event = {
            name: "chatTags",
            value: selectedValues,
          };
          changeBlock(event); // Notifica o componente pai
        }}
        defaultValue={block?.data?.chatTags} // Usa o estado local
        placeholder={t('reactionCards.tagSelect.placeholder', 'Selecionar tags')}
        variant="inverted"
        animation={2}
        maxCount={3}
      />

      <div className="mt-8">
        <AlertInfo

          title={t('status.warning', { ns: 'common', defaultValue: 'Atenção' })}
          description={t('reactionCards.addTag.alertDescription', 'Se não houver nenhum chat vinculado, a tag não será adicionada.')}
        />
      </div>

    </div>
  );
};

export default ChatAddTag;